import React, { useEffect, useState } from "react";
import { telemetryService } from "../../../services/TelemetryService";
import CreateSingleEdgeConfig from "./CreateSingleEdgeConfig";
import { Link } from "react-router-dom";
import { TextField, Button, Switch, Divider, Card, CardContent, LinearProgress } from "@mui/material";
import { TopToolbar, useNotify } from "react-admin";

const DEVICE_TYPE_V3 = "V3";
const DEVICE_TYPE_POLARIS = "Polaris";

export default function CreateEdgeConfig({ deviceType, ...props }) {
    const [serialNum, setSerialNum] = useState("");
    const [config, setConfig] = useState("");
    const [isLoading, setLoading] = useState(true);
    const [isDefaultTemplate] = useState(true);

    const notify = useNotify();

    useEffect(() => {
        if (deviceType) {
            const fetchConfig = async () => {
                setLoading(true);

                const configId = deviceType === DEVICE_TYPE_POLARIS ? "generic_polaris_config" : "generic_v3_config";

                try {
                    const response = await telemetryService.getEdgeConfig(configId);
                    const deviceConfig = response.data.device_config;

                    setConfig(deviceConfig);
                    setLoading(false);
                } catch (e) {
                    console.error(e);

                    notify(`Something went wrong loading the config for "${configId}"`);
                }
            };

            fetchConfig();
        }
    }, [deviceType]);

    if (isLoading) {
        return <LinearProgress />;
    }

    return (
        <>
            <TopToolbar>
                <Button
                    component={Link}
                    to={{
                        pathname: props.basePath,
                    }}
                    color="primary"
                >
                    Back
                </Button>
            </TopToolbar>

            <div style={{ margin: "1em" }}>
                <Divider style={{ marginTop: 30 }} />

                {!isLoading && config && (
                    <div style={{ marginBottom: ".5em" }}>
                        <TextField
                            style={{ margin: ".5em" }}
                            id="outlined-search"
                            label="Device Serial Number"
                            value={serialNum}
                            type="search"
                            variant="outlined"
                            onChange={(event) => setSerialNum(event.target.value)}
                        />
                    </div>
                )}

                {!isLoading && config && (
                    <CreateSingleEdgeConfig
                        configFile={config}
                        serialNum={serialNum}
                        deviceType={deviceType}
                        isDefaultTemplate={isDefaultTemplate}
                    />
                )}
            </div>
        </>
    );
}
